import {createFormActionTypes} from "../../../../../shared/ts/helpers/create_form_action_types";
import {createFormActions} from "../../../../../shared/ts/helpers/create_form_actions";

export const SURPRISE_FILTER_PREFIX = "surprise/filter_list";
export const filterSurpriseListFormTypes = createFormActionTypes(SURPRISE_FILTER_PREFIX);
export const filterSurpriseListFormActions = createFormActions(filterSurpriseListFormTypes);
